import React, { useRef, useState } from "react";
import "./ForgotPassword.css";
import { forgotPassword } from "../../../Redux/Actions/AuthActions/ForgotPasswordAction";
import { useAppThunkDispatch } from "../../../Redux/hooks";
import AuthLeft from "../../Shared/AuthLeft/AuthLeft";
import AuthActionBtn from "../../Shared/AuthActionBtn/AuthActionBtn";
import { toast } from "react-hot-toast";
import ForgotPasswordOtpStep from "./ForgotPasswordOtpStep";
import ForgotPasswordResetStep from "./ForgotPasswordResetStep";

type Step = "email" | "otp" | "reset";

const ForgotPassword = () => {
  const email = useRef<HTMLInputElement | null>(null);
  const dispatch = useAppThunkDispatch();
  const [isFetching, setIsFetching] = useState(false);
  const [step, setStep] = useState<Step>("email");
  const [submittedEmail, setSubmittedEmail] = useState("");
  const [verifiedOtp, setVerifiedOtp] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    const emailValue = (email.current?.value ?? "").trim().toLowerCase();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(emailValue)) {
      toast.error("Please enter a valid email address.");
      return;
    }

    setIsFetching(true);
    const result = await dispatch(forgotPassword({ email: emailValue }));
    setIsFetching(false);

    if (result.success) {
      setSubmittedEmail(emailValue);
      toast.success("Verification code sent to your email.");
      setStep("otp");
    } else {
      toast.error(result.message || "Failed to send verification code.");
    }
  };

  return (
    <div className="ForgotPassword">
      <div className="loginWrapper">
        <AuthLeft />
        <div className="loginRight">
          <div className="loginBox">
            {step === "email" && (
              <form onSubmit={handleSubmit} className="ForgotPasswordBox forgotPasswordStep">
                <p className="forgotPasswordStepTitle">Forgot password</p>
                <p className="forgotPasswordStepHint">
                  Enter your email and we&apos;ll send you a 6-digit verification code.
                </p>
                <label className="forgotPasswordFieldLabel" htmlFor="forgot-password-email">
                  Email address
                </label>
                <input
                  id="forgot-password-email"
                  placeholder="you@example.com"
                  type="email"
                  ref={email}
                  required
                  autoComplete="email"
                  className="forgotPasswordField"
                />
                <AuthActionBtn isFetching={isFetching} ForgotPas={true} />
              </form>
            )}

            {step === "otp" && (
              <ForgotPasswordOtpStep
                email={submittedEmail}
                onVerified={(code) => {
                  setVerifiedOtp(code);
                  setStep("reset");
                }}
                onBack={() => setStep("email")}
              />
            )}

            {step === "reset" && (
              <ForgotPasswordResetStep
                email={submittedEmail}
                otp={verifiedOtp}
                onBack={() => setStep("otp")}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
